import React from "react";

import { Period } from "@state/common/PeriodConverter";

import { ExpandedPeriodMenuItem } from ".";

export function ExpandedPeriodMenuItems(props: {
	store: {
		toggleUpdateProcessing: () => void;
		periodSubMenu: {
			setPeriodKey: (p: Period) => void;
			periodMenu: { period: Period; name: string }[];
		};
	};
}) {
	return (
		<>
			{props.store.periodSubMenu.periodMenu.map((period) => (
				<ExpandedPeriodMenuItem
					key={period.period}
					period={period.period}
					name={period.name}
					store={props.store}
				/>
			))}
		</>
	);
}
